class SiteHeader {

    constructor(headerSelector) {
        this.header = document.querySelector(headerSelector);
        if (!this.header) {
            return;
        }

        this.hamburger = this.header.querySelector('.hamburger');
        this.close = this.header.querySelector('.mobile__nav--close');
        this.mobileNav = this.header.querySelector('.mobile__nav');


        this._bindEvents();
    } 

    _bindEvents() {
        this.hamburger?.addEventListener('click', ()=> this._openMenu());
        this.close?.addEventListener('click', ()=> this._closeMenu());
    }

    _openMenu() {
        this.mobileNav?.removeAttribute('hidden');
        this.hamburger.setAttribute('aria-expanded', true);
        document.body.style.overflow = 'hidden';
    }

    _closeMenu() {
        this.mobileNav?.setAttribute('hidden',  '');
        this.hamburger.setAttribute('aria-expanded', false);
        document.body.style.overflow = '';
    }

}


document.addEventListener('DOMContentLoaded', () => {
  new SiteHeader('.site-header');
});